var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/cta-button.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/contentful/cta-button.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("contentfulUrl")) {
var t_4 = t_1.contentfulUrl;
} else {
cb(new Error("cannot import 'contentfulUrl'")); return;
}
context.setVariable("contentfulUrl", t_4);
output += "\n\n";
var macro_t_5 = runtime.makeMacro(
[], 
["baseClass", "ctaObject", "defaultButtonClass", "CTAFullWidthClass", "CTALayoutClass"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("baseClass", kwargs.hasOwnProperty("baseClass") ? kwargs["baseClass"] : "editorial");
frame.set("ctaObject", kwargs.hasOwnProperty("ctaObject") ? kwargs["ctaObject"] : {});
frame.set("defaultButtonClass", kwargs.hasOwnProperty("defaultButtonClass") ? kwargs["defaultButtonClass"] : "c-cta-button--button1");
frame.set("CTAFullWidthClass", kwargs.hasOwnProperty("CTAFullWidthClass") ? kwargs["CTAFullWidthClass"] : "");
frame.set("CTALayoutClass", kwargs.hasOwnProperty("CTALayoutClass") ? kwargs["CTALayoutClass"] : "");
var t_6 = "";t_6 += "<ul class=\"c-";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "baseClass"), env.opts.autoescape);
t_6 += "__ul\">\n\n        ";
frame = frame.push();
var t_9 = runtime.contextOrFrameLookup(context, frame, "ctaObject");
if(t_9) {var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("ctaLink", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
t_6 += "\n\n            ";
var t_11;
t_11 = (lineno = 8, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.linkPath",""]));
frame.set("cleanUrl", t_11, true);
if(frame.topLevel) {
context.setVariable("cleanUrl", t_11);
}
if(frame.topLevel) {
context.addExport("cleanUrl", t_11);
}
t_6 += "\n            ";
var t_12;
t_12 = (lineno = 9, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.linkTitle"]));
frame.set("linkTitle", t_12, true);
if(frame.topLevel) {
context.setVariable("linkTitle", t_12);
}
if(frame.topLevel) {
context.addExport("linkTitle", t_12);
}
t_6 += "\n            ";
var t_13;
t_13 = (lineno = 10, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.openInNewWindow"]));
frame.set("openInNewWindow", t_13, true);
if(frame.topLevel) {
context.setVariable("openInNewWindow", t_13);
}
if(frame.topLevel) {
context.addExport("openInNewWindow", t_13);
}
t_6 += "\n            ";
var t_14;
t_14 = runtime.contextOrFrameLookup(context, frame, "baseClass") + "|" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index");
frame.set("gaAction", t_14, true);
if(frame.topLevel) {
context.setVariable("gaAction", t_14);
}
if(frame.topLevel) {
context.addExport("gaAction", t_14);
}
t_6 += "\n            ";
var t_15;
t_15 = env.getFilter("replace").call(context, runtime.contextOrFrameLookup(context, frame, "cleanUrl"),"/","");
frame.set("gaLabel", t_15, true);
if(frame.topLevel) {
context.setVariable("gaLabel", t_15);
}
if(frame.topLevel) {
context.addExport("gaLabel", t_15);
}
t_6 += "\n\n            ";
var t_16;
t_16 = ((lineno = 15, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.buttonTextStyle"]))?"c-cta-button--" + (lineno = 14, colno = 67, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.buttonTextStyle"])):runtime.contextOrFrameLookup(context, frame, "defaultButtonClass"));
frame.set("buttonTextStyle", t_16, true);
if(frame.topLevel) {
context.setVariable("buttonTextStyle", t_16);
}
if(frame.topLevel) {
context.addExport("buttonTextStyle", t_16);
}
t_6 += "\n\n            ";
var t_17;
t_17 = ((lineno = 18, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.buttonTextColor"]))?"color: #" + env.getFilter("replace").call(context, (lineno = 17, colno = 61, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.buttonTextColor"])),"#","") + ";":"");
frame.set("buttonTextColor", t_17, true);
if(frame.topLevel) {
context.setVariable("buttonTextColor", t_17);
}
if(frame.topLevel) {
context.addExport("buttonTextColor", t_17);
}
t_6 += "\n\n            ";
var t_18;
t_18 = ((lineno = 21, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.buttonBackgroundColor"]))?"background-color: #" + env.getFilter("replace").call(context, (lineno = 20, colno = 78, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.buttonBackgroundColor"])),"#","") + ";":"");
frame.set("buttonBackgroundColor", t_18, true);
if(frame.topLevel) {
context.setVariable("buttonBackgroundColor", t_18);
}
if(frame.topLevel) {
context.addExport("buttonBackgroundColor", t_18);
}
t_6 += "\n\n            ";
var t_19;
t_19 = ((lineno = 24, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.buttonBorderColor"]))?"border-color: #" + env.getFilter("replace").call(context, (lineno = 23, colno = 70, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_10,"fields.buttonBorderColor"])),"#","") + ";":"");
frame.set("buttonBorderColor", t_19, true);
if(frame.topLevel) {
context.setVariable("buttonBorderColor", t_19);
}
if(frame.topLevel) {
context.addExport("buttonBorderColor", t_19);
}
t_6 += "\n\n            <li class=\"c-cta-button__li ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "CTALayoutClass"), env.opts.autoescape);
t_6 += "\" data-qa-";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "baseClass"), env.opts.autoescape);
t_6 += "-cta>\n\n                <a class=\"c-cta-button ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "buttonTextStyle"), env.opts.autoescape);
t_6 += " ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "CTAFullWidthClass"), env.opts.autoescape);
t_6 += "\"\n                    href=\"";
t_6 += runtime.suppressValue((lineno = 29, colno = 40, runtime.callWrap(t_4, "contentfulUrl", context, [runtime.contextOrFrameLookup(context, frame, "cleanUrl")])), env.opts.autoescape);
t_6 += "\"\n                    style=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "buttonTextColor"), env.opts.autoescape);
t_6 += " ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "buttonBackgroundColor"), env.opts.autoescape);
t_6 += " ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "buttonBorderColor"), env.opts.autoescape);
t_6 += "\"\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "openInNewWindow")) {
t_6 += " target=\"_blank\" rel=\"noopener noreferrer\" ";
;
}
t_6 += "\n                    data-qa-";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "baseClass"), env.opts.autoescape);
t_6 += "-cta-link\n                    ";
t_6 += runtime.suppressValue((lineno = 33, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE",runtime.contextOrFrameLookup(context, frame, "gaAction"),runtime.contextOrFrameLookup(context, frame, "gaLabel")])), env.opts.autoescape);
t_6 += ">\n\n                    ";
t_6 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "linkTitle")?runtime.contextOrFrameLookup(context, frame, "linkTitle"):(lineno = 35, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-tray_see-more"]))), env.opts.autoescape);
t_6 += "\n\n                </a>\n\n            </li>\n\n        ";
;
}
}
frame = frame.pop();
t_6 += "\n\n    </ul>";
;
frame = frame.pop();
return new runtime.SafeString(t_6);
});
context.addExport("buildCtaButtons");
context.setVariable("buildCtaButtons", macro_t_5);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/cta-button.j2"] , dependencies)